import styled from "styled-components";
import SectionHeaderAndContent from "../../components/SectionHeaderAndContent";
import { CommaSeparatedList } from "../../config/StyledComponents";
import dayjs from "dayjs";
import { useExtraFieldsContext } from "../../contexts/ExtraFieldsContext";

const ConfirmRequestGridLayout = ({
  data,
  formData,
  pdfNames,
  contactNum,
  isGuestOr,
}) => {
  let selectedAirlines = formData.perferAirline.filter((item) => item.selected);
  const { extraFields } = useExtraFieldsContext();
  return (
    <>
      <TravellerDetailsGrid>
        {data.relationshipStatus === "Self" && (
          <TravellerDetailsGridItem>
            <SectionHeaderAndContent
              heading="Employee ID"
              content={data.empId}
              headerFontWeight="500"
              contentFontSize="0.875rem"
              contentFontWeight="500"
            />
          </TravellerDetailsGridItem>
        )}
        {data.relationshipStatus === "Self" && (
          <TravellerDetailsGridItem>
            <SectionHeaderAndContent
              heading="Contact Number"
              content={contactNum}
              headerFontWeight="500"
              contentFontSize="0.875rem"
              contentFontWeight="500"
            />
          </TravellerDetailsGridItem>
        )}
        <TravellerDetailsGridItem>
          <SectionHeaderAndContent
            heading="Passport Number"
            content={data.passportNo}
            headerFontWeight="500"
            contentFontSize="0.875rem"
            contentFontWeight="500"
          />
        </TravellerDetailsGridItem>
        <TravellerDetailsGridItem>
          <SectionHeaderAndContent
            heading="Passport Expiry"
            content={
              data.passportExpiry &&
              dayjs(data.passportExpiry).format("MMM DD, YYYY")
            }
            headerFontWeight="500"
            contentFontSize="0.875rem"
            contentFontWeight="500"
          />
        </TravellerDetailsGridItem>
        <TravellerDetailsGridItem>
          <SectionHeaderAndContent
            heading="Passport"
            content={
              isGuestOr === "guest"
                ? pdfNames
                : data?.passportPdf
                ? `${data.firstName}.pdf`
                : ""
            }
            headerFontWeight="500"
            contentFontSize="0.875rem"
            contentFontWeight="500"
            contentFontColor="#418DF9"
            onClick={() =>
              data?.passportPdf && window.open(data?.passportPdf, "_blank")
            }
          />
        </TravellerDetailsGridItem>
        <TravellerDetailsGridItem>
          <SectionHeaderAndContent
            heading="Date of Birth"
            content={dayjs(data?.dob).format("MMM DD, YYYY")}
            headerFontWeight="500"
            contentFontSize="0.875rem"
            contentFontWeight="500"
          />
        </TravellerDetailsGridItem>
        <TravellerDetailsGridItem>
          <SectionHeaderAndContent
            heading="Payment Type"
            content={data?.paymentType}
            headerFontWeight="500"
            contentFontSize="0.875rem"
            contentFontWeight="500"
          />
        </TravellerDetailsGridItem>
        <TravellerDetailsGridItem>
          <SectionHeaderAndContent
            heading="Travel Class"
            content={data?.travelType}
            headerFontWeight="500"
            contentFontSize="0.875rem"
            contentFontWeight="500"
          />
        </TravellerDetailsGridItem>
        <TravellerDetailsGridItem>
          <SectionHeaderAndContent
            heading="Phone Number"
            content={extraFields?.contactNum || '-'}
            headerFontWeight="500"
            contentFontSize="0.875rem"
            contentFontWeight="500"
          />
        </TravellerDetailsGridItem>
        <TravellerDetailsGridItem gridColumn>
          <SectionHeaderAndContent
            heading="Airlines"
            content={
              <>
                {selectedAirlines.length > 0 ? (
                  <CommaSeparatedList>
                    {formData.perferAirline.map(
                      (item) => item.selected && <li>{item.label}</li>
                    )}
                  </CommaSeparatedList>
                ) : (
                  <div>-</div>
                )}
              </>
            }
            headerFontWeight="500"
            contentFontSize="0.875rem"
            contentFontWeight="500"
          />
        </TravellerDetailsGridItem>
      </TravellerDetailsGrid>
    </>
  );
};

export const TravellerDetailsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.25rem 4.125rem;
  margin-top: 1.25rem;

  @media only screen and (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.125rem 5.813rem;
  }

  @media only screen and (max-width: 500px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.125rem 0.813rem;
  }

  @media only screen and (max-width: 380px) {
    // grid-template-columns: repeat(1, 1fr);
    // gap: 1rem 0rem;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }
`;

export const TravellerDetailsGridItem = styled.div`
  grid-column: ${(props) => props.gridColumn && "span 2"};
  @media only screen and (max-width: 380px) {
    grid-column: none;
  }
`;

export default ConfirmRequestGridLayout;
